export function MediamarktTermsNL() {
  return (
    <article>
      <h1>Algemene voorwaarden</h1>
      <time dateTime="2024-09-01">September 2024</time>

      <div>
        <h3>1. Algemeen</h3>
        <p>
          Jotta AS ("Jottacloud") biedt een cloudopslagdienst ("Dienst") die het
          mogelijk maakt om bestanden via het internet op te slaan, te
          back-uppen, te synchroniseren en te delen. Deze servicevoorwaarden
          (“Overeenkomst”) samen met ons Privacybeleid, vormen een wettelijk
          bindende overeenkomst tussen Jottacloud en u als gebruiker.
          Verwijzingen naar "wij," "onze," en "ons" verwijzen naar Jottacloud
          terwijl "u," "uw," en "gebruiker" naar de gebruiker verwijzen. Door de
          Dienst te gebruiken, gaat u akkoord met en bent u gebonden aan de
          voorwaarden van deze Overeenkomst.
        </p>
        <h3>2. Gebruikersaccount</h3>
        <p>
          U moet een Jottacloud-account aanmaken om de Dienst te gebruiken. De
          beschikbare abonnementen worden beschreven in het overzicht van
          prijzen en abonnementen van Jottacloud. De abonnementsvormen omvatten
          een gratis account, een persoonlijk account voor één gebruiker, een
          persoonlijk account voor meerdere gebruikers en een bedrijfsaccount.
        </p>
        <h3>3. Gratis account</h3>
        <p>
          Een gratis account wordt kosteloos aangeboden met bepaalde beperkingen
          op opslagcapaciteit en functies. Jottacloud behoudt zich het recht
          voor om andere beperkingen toe te passen op gratis accounts en
          betaalde advertenties te tonen. Een gratis account kan door Jottacloud
          worden opgeheven als het voor een periode van één jaar of langer
          inactief is geweest.
        </p>
        <h3>4. Persoonlijk account met een of meer gebruikers</h3>
        <p>
          Een persoonlijk account met een of meer gebruikers is exclusief
          beschikbaar voor individueel privégebruik en niet voor bedrijven,
          organisaties, of soortgelijke entiteiten. Een persoonlijk account met
          een of meer gebruikers kan niet worden gebruikt om gegevens op te
          slaan in een commerciële context en bevat een opslagcapaciteit en
          functies in overeenstemming met het gekozen abonnement. Persoonlijke
          accounts omvatten zowel abonnementen voor één gebruiker als deelbare
          abonnementen voor maximaal vijf gebruikers.
        </p>
        <p>
          Een persoonlijk account met een of meer gebruikers heeft een looptijd
          van één of twaalf maanden en wordt daarna automatisch verlengd voor
          een nieuwe abonnementsperiode (één of twaalf maanden) tenzij de
          gebruiker het betaalde abonnement voor het einde van de huidige
          abonnementsperiode heeft opgezegd. De creditcard van de gebruiker
          wordt automatisch belast bij het verlengen van een abonnement.
          Betalingen worden niet gerestitueerd, zelfs als de gebruiker het
          abonnement annuleert. De gebruiker kan het abonnement op elk gewenst
          moment annuleren of wijzigen. Bij het aanmaken van een persoonlijk
          account met meerdere gebruikers, wordt automatisch een beheerder
          toegewezen. Het is de verantwoordelijkheid van de beheerder om het
          abonnement en de bijbehorende leden toe te voegen en te onderhouden.
          De beheerder zal de leden van het abonnement identificeren door voor
          elk lid het e-mailadres of telefoonnummer op te geven.
        </p>
        <p>
          De beheerder is verantwoordelijk voor het betalen van de
          gebruikskosten voor het abonnement voor alle leden. De beheerder van
          een persoonlijk account met meerdere gebruikers heeft geen toegang tot
          de gegevens die op de accounts van leden zijn opgeslagen, tenzij deze
          gegevens met de beheerder worden gedeeld. Leden hebben alleen toegang
          tot hun eigen bestanden, tenzij andere leden hun bestanden hebben
          gedeeld. Leden kunnen gegevens en bestanden met anderen delen.
        </p>
        <p>
          Een beheerder kan het account op elk gewenst moment upgraden
          (opslagruimte of leden toevoegen) of downgraden (opslagruimte of het
          aantal leden verminderen), of de looptijd van het abonnement wijzigen.
          De beheerder kan een persoonlijk account met meerdere gebruikers op
          elk moment annuleren. In het geval van een annulering worden alle
          opgeslagen gegevens binnen 90 dagen na de datum van annulering
          verwijderd.
        </p>
        <h3>5. Bedrijfsaccount</h3>
        <p>
          Een bedrijfsaccount kan worden aangemaakt door een bedrijf, een
          organisatie of een individu. Bij het aanmaken van een bedrijfsaccount
          wordt automatisch een beheerder toegewezen. Het is de
          verantwoordelijkheid van de beheerder om het bedrijfsaccount en de
          bijbehorende leden toe te voegen en te onderhouden.Er zijn specifieke
          voorwaarden van toepassing op bedrijfsaccounts, raadpleeg sectie 6
          voor meer informatie.
        </p>
        <h3>6. Speciale voorwaarden voor bedrijfsaccounts</h3>
        <p>
          Als u een bedrijfsaccount hebt, is deze sectie (Speciale voorwaarden
          voor bedrijfsaccounts) van toepassing op uw gebruik van de Dienst. Een
          bedrijfsaccount wordt ingesteld door een beheerder voor
          bedrijfsaccounts ("Beheerder"). De beheerder kiest het soort
          bedrijfsabonnement, voegt leden ("Leden") aan het account toe en zal
          voor elk lid een afzonderlijk account aanmaken.
        </p>
        <p>
          De beheerder zal de leden van het bedrijfsaccount identificeren door
          voor elk lid het e- mailadres op te geven. De beheerder is
          verantwoordelijk voor het betalen van de gebruikskosten voor het
          bedrijfsaccount voor alle leden. De beheerder heeft exclusieve
          controle over het beheer van alle accounts van de leden en zorgt
          ervoor dat het gebruik van de Dienst voldoet aan deze Overeenkomst en
          enige verdere instructies van Jottacloud. Het is de volledige
          verantwoordelijkheid van de beheerder om te verzekeren dat de
          opslagcapaciteit voor de leden naar behoefte wordt verhoogd of
          verlaagd. De beheerder heeft eveneens de verantwoordelijkheid om
          afzonderlijke accounts waar nodig toe te voegen of te verwijderen.
          Bedrijfsaccounts zijn niet in staat om extra opslagruimte te krijgen.
        </p>
        <p>
          De beheerder heeft geen toegang tot de gegevens die op de accounts van
          leden zijn opgeslagen, tenzij deze gegevens met de beheerder worden
          gedeeld. De beheerder heeft toegang tot de activiteit op accounts van
          leden en kan zodoende bestands- en mapnamen lezen met geüploade
          bestanden en andere informatie over accountactiviteiten. Leden hebben
          alleen toegang tot hun eigen bestanden, tenzij andere leden hun
          bestanden hebben gedeeld. Leden kunnen gegevens en bestanden met
          anderen delen. Het bedrijfsabonnement wordt, afhankelijk van de keuze
          van de beheerder, automatisch maandelijks of jaarlijks verlengd. Een
          beheerder kan het account op elk gewenst moment upgraden (opslagruimte
          of het aantal accounts toevoegen) of downgraden (opslagruimte of het
          aantal accounts verminderen), of de looptijd van het abonnement
          wijzigen. Dergelijke wijzigingen worden van kracht aan het einde van
          de looptijd van het huidige abonnement. De beheerder kan een
          bedrijfsaccount op elk moment annuleren. Alle opgeslagen gegevens
          worden bij een dergelijke annulering verwijderd.
        </p>
        <h3>7. Licentie om de Dienst te gebruiken</h3>
        <p>
          Wanneer een gebruiker zich, in overeenstemming met de
          licentievoorwaarden en de instructies van Jottacloud, aanmeldt voor
          een account, verleent Jottacloud het recht om de Dienst te gebruiken.
        </p>
        <p>
          De gebruiker mag de Dienst alleen gebruiken binnen het doel en met de
          beperkingen en instructies die zijn vastgesteld door Jottacloud.
          Jottacloud verleent een niet-exclusieve, niet-overdraagbare licentie
          om de Dienst te installeren en te gebruiken voor het opgegeven doel.
          De licentie kan niet aan anderen worden overgedragen of anderszins aan
          anderen ter beschikking worden gesteld, buiten hetgeen wat in deze
          Overeenkomst is bepaald.
        </p>
        <p>
          Er kan bij de Dienst broncode van derden worden verstrekt die
          onderhevig is aan de toepasselijke licenties van derden. De Dienst en
          zijn structuur, organisatie, broncode en documentatie bevatten
          handelsgeheimen.
        </p>
        <p>
          Jottacloud is de enige eigenaar van de Dienst en de software die wordt
          gebruikt om de Dienst te leveren, evenals alle bijbehorende
          documentatie.
        </p>
        <p>
          De Dienst stelt de gebruiker in staat om digitale inhoud te delen, te
          verzenden, en met anderen uit te wisselen. De gebruiker moet over alle
          benodigde rechten beschikken om deze digitale inhoud te verspreiden.
          Door de Dienst te gebruiken, erkent u dat Jottacloud geen controle
          heeft over de digitale inhoud die via de Dienst wordt verzonden of
          gebruikt, en Jottacloud kan op geen enkele manier verantwoordelijk
          worden gesteld voor het gebruik, de inhoud of de opslag van deze
          digitale inhoud.
        </p>
        <p>
          Jottacloud voldoet te allen tijde aan de toepasselijke Noorse wet en
          behoudt zich het recht voor om materiaal te verwijderen of andere
          beperkingen op te leggen die noodzakelijk worden geacht om de naleving
          van de toepasselijke wetgeving en voorschriften te waarborgen.
        </p>
        <p>
          Jottacloud behoudt zich het recht voor om controle op virussen uit te
          voeren en kan het uploaden van bepaalde bestanden blokkeren.
        </p>
        <p>
          De gebruiker mag geen commercieel gebruik maken van de Service, met
          inbegrip van maar niet beperkt tot het verkopen of verspreiden van de
          Dienst, software, of documentatie aan derden.
        </p>
        <h3>8. Upgraden en downgraden</h3>
        <p>
          U kunt upgraden van een gratis account naar ofwel een persoonlijk
          account ofwel een thuisabonnement door de procedures te volgen voor
          het upgraden van Jottacloud. U kunt eveneens downgraden van een
          persoonlijk account of thuisabonnement naar een gratis account. Het
          downgraden van een account houdt een overstap in van een persoonlijk
          account of thuisabonnement naar een gratis account. Voordat u een
          dergelijke downgrade kunt uitvoeren, moet u alle bestanden verwijderen
          uit uw persoonlijk account of thuisabonnement om ervoor te zorgen dat
          de totale hoeveelheid gegevens de huidige opslaglimiet voor een gratis
          account niet overschrijdt. Voor familie-accounts moet u eerst alle
          andere leden verwijderen voordat u kunt downgraden naar een
          individueel of gratis account.
        </p>
        <h3>9. Verlenging, beëindiging en opzegging van een abonnement</h3>
        <p>
          Abonnementen voor persoonlijke accounts, thuisabonnementen en
          bedrijfsaccounts worden automatisch verlengd wanneer de
          abonnementsperiode verloopt. De gebruiker kan het abonnement op elk
          gewenst moment beëindigen. Als een abonnement eenmaal is beëindigd,
          wordt het niet meer verlengd bij het aflopen van de
          abonnementsperiode. Nadat een abonnement is beëindigd, zal Jottacloud
          het account van de gebruiker beëindigen of downgraden naar een gratis
          account. Als het account meer gegevens bevat dan is toegestaan voor
          gratis accounts, worden alle bestanden in het account verwijderd bij
          de downgrade. U kunt uw gebruikersaccount op elk gewenst moment
          verwijderen op de pagina “Account en profiel” in de instellingen. Als
          de gebruiker nalaat de vergoedingen of andere aan Jottacloud
          verschuldigde bedragen te betalen, heeft Jottacloud het recht om het
          account 90 dagen na de oorspronkelijke betalingstermijn te beëindigen.
          Een abonnement dat op deze basis wordt stopgezet, kan na een
          opzegtermijn door Jottacloud worden beëindigd. Een dergelijke
          beëindiging houdt in dat alle bestanden en gegevens worden verwijderd.
          Jottacloud heeft het recht om het account van een gebruiker te
          beëindigen als deze gebruiker op een manier handelt die niet in
          overeenstemming is met deze Overeenkomst of de instructies die zijn
          verstrekt door Jottacloud. De bijbehorende gebruikersgegevens worden
          binnen 90 dagen na beëindiging van het account verwijderd.
        </p>
        <h3>10. Vereiste leeftijd</h3>
        <p>
          De minimumleeftijd voor het aanmaken van een gratis, individueel, of
          familie-account is 13 jaar. Als blijkt dat de gebruiker die het
          account heeft aangemaakt jonger is dan 13 jaar, heeft Jottacloud het
          recht om alle informatie te verwijderen, inclusief het
          gebruikersaccount, de gegevens en de bestanden. De beheerder voor
          familie- accounts moet ouder zijn dan 13 jaar.
        </p>
        <h3>11. Wijzigingen in persoonsgegevens</h3>
        <p>
          De gebruiker moet Jottacloud onverwijld op de hoogte stellen van
          wijzigingen in hun e- mailadres of betaalgegevens door de
          accountinstellingen in de instellingen bij te werken. De gebruiker is
          als enige verantwoordelijk voor eventuele kosten die voortvloeien uit
          onjuiste of ontbrekende wijzigingen in de gebruikersinformatie.
        </p>
        <h3>12. Privacy en gegevensverzameling</h3>
        <p>
          Jottacloud kan informatie verzamelen die niet persoonlijk
          identificeerbaar is en betrekking heeft op het gebruik van de Dienst.
          Deze informatie omvat statistieken en prestatiemetingen in verband met
          de software. Dergelijke gegevens worden naar Jottacloud verzonden en
          kunnen alleen worden gebruikt door Jottacloud en zoals bepaald in het
          Privacybeleid. In geval van een geldig rechterlijk bevel van een
          Noorse rechtbank, zal Jottacloud gegevens vrijgeven in overeenstemming
          met het gerechtelijk bevel. Jottacloud zal de gebruiker in dergelijke
          gevallen en voor zover wettelijk toegelaten op de hoogte stellen.
        </p>
        <h3>13. Extra opslagruimte</h3>
        <p>
          U kunt extra gratis opslagruimte ("Extra opslagruimte") verdienen voor
          uw account. Extra opslagruimte is gratis opslagruimte die voor
          beperkte tijd beschikbaar wordt gesteld op uw gebruikersaccount. Extra
          opslagruimte is alleen van toepassing op gratis accounts en
          individuele accounts. Jottacloud behoudt zich het recht voor om de
          voorwaarden van extra opslagruimte te annuleren of te wijzigen.
        </p>
        <h3>14. Vereisten om de Dienst te gebruiken</h3>
        <p>
          Voor gebruik van de Dienst moet u in bezit zijn van een compatibele
          computer en/of mobiel apparaat met toegang tot het internet. Als u de
          Dienst via een draadloze verbinding gebruikt, kan uw mobiele provider
          extra kosten in rekening brengen. U bent verantwoordelijk voor het
          betalen van alle kosten en voor de apparatuur en andere diensten van
          derden die u nodig heeft om toegang te krijgen tot de Dienst.
        </p>
        <p>
          De gebruiker is verantwoordelijk voor het onthouden en voor een
          vertrouwelijke opslag van het wachtwoord. De gebruiker is eveneens
          verantwoordelijk voor de activiteit die plaatsvindt onder hun
          gebruikersnaam. Als de gebruiker het wachtwoord voor het account
          verliest, gaat mogelijk ook de toegang tot de bijbehorende gegevens
          verloren. De gebruikersnaam en het wachtwoord van de gebruiker zijn
          persoonlijk en kunnen niet worden gedeeld met derden. Als de gebruiker
          zich bewust wordt van misbruik van hun account, moeten ze Jottacloud
          hier onmiddellijk van op de hoogte stellen.
        </p>
        <h3>15. Eerlijk en aanvaardbaar gebruik</h3>
        <p>
          Het gebruik van de producten en diensten van Jottacloud moet voldoen
          aan de beginselen die in deze Overeenkomst worden beschreven en de
          toepasbare wet- en regelgeving. Jottacloud kan operationele routines
          instellen of uitbreiden om de beschikbaarheid van de Dienst te
          garanderen en misbruik te voorkomen.
        </p>
        <p>
          Als onderdeel van deze operationele routines behouden we het recht
          voor om onze systemen te controleren en overmatig gebruik van opslag
          en netwerkbronnen te identificeren, en om naar ons goeddunken
          technische en andere maatregelen te nemen. Er kunnen beperkingen op de
          bandbreedte en het aantal API calls worden geïmplementeerd.
        </p>
        <p>
          Het persoonlijk abonnement van Jottacloud met onbeperkte opslag is
          ontworpen om de klant voorspelbaarheid te bieden. De term “onbeperkt”
          verwijst naar de beschikbare opslagruimte.
        </p>
        <p>
          Gebruikers met een persoonlijk account of thuisabonnement kunnen de
          Dienst gebruiken voor normaal, niet-commercieel gebruik. We behouden
          ons het recht voor om overmatig gebruik en misbruik van de Dienst te
          voorkomen.
        </p>
        <p>
          Als het totale opslag en netwerkgebruik van een gebruiker aanzienlijk
          hoger is dan het normale gebruik van een gemiddelde
          Jottacloud-gebruiker, en/of erop wijst dat de Dienst wordt gebruikt
          voor een ander doel dan persoonlijk of niet-commercieel gebruik, wordt
          dit mogelijk beschouwd als misbruik van de Dienst.
        </p>
        <p>
          In de bovengenoemde gevallen behouden we ons het recht voor om een
          alternatief abonnement op Jottacloud aan te bieden, of de relatie met
          de klant te beëindigen, of om het account van de gebruiker en/of de
          gebruikersgegevens te verwijderen. In dergelijke gevallen nemen we
          contact op met de gebruiker met een voorstel voor wijziging of een
          kennisgeving van actie.
        </p>
        <p>
          Gebruikers mogen de accounts of de diensten van het account niet
          doorverkopen. U mag uw wachtwoord niet met derden delen en u moet het
          op een veilige en geschikte manier bewaren. Het gebruik van de
          diensten en/of producten van Jottacloud voor illegale activiteiten
          wordt beschouwd als een schending van deze Overeenkomst.
        </p>
        <p>
          U mag geen gegevens op de Dienst opslaan en/of verspreiden die de
          Noorse wet- en regelgeving schendt, met inbegrip van privacy- en
          auteurswetten. Dit omvat kinderpornografie, vervalst materiaal en/of
          ander illegaal of auteursrechtelijk beschermd materiaal.
        </p>
        <p>
          Gebruikersaccounts die worden gebruikt voor het opslaan en/of delen
          van illegaal of auteursrechtelijk beschermd materiaal op de Dienst
          worden beëindigd. Jottacloud behoudt zich het recht voor om de toegang
          te blokkeren of het gebruik van de Dienst te verbieden,
          gebruikersgegevens en/of gebruikersaccounts te verwijderen als wij van
          mening zijn dat de gebruiker deze Overeenkomst schendt.
        </p>
        <p>
          Het opslaan en/of verspreiden van gegevens die de Noorse wetgeving
          schenden, kan worden gemeld aan de autoriteiten.
        </p>
        <h3>16. Aansprakelijkheid en garantie</h3>
        <p>
          De volledige aansprakelijkheid van Jottacloud voor elke vorm van
          schade, kosten of verlies met betrekking tot de Dienst, met inbegrip
          van het verlies van gegevens, is in ieder geval beperkt tot een bedrag
          dat gelijk is aan de betaalde kosten voor het desbetreffende account
          in de laatste 12 maanden vóór het ontstaan van de vordering.
          Jottacloud is niet aansprakelijk voor enige vorm van indirecte of
          gevolgschade. Deze beperkingen zijn overeengekomen door de partijen en
          zullen van toepassing zijn tenzij anders wordt vereist door bindende
          wettelijke bepalingen.
        </p>
        <h3>17. Marketing en communicatie in elektronische kanalen</h3>
        <p>
          Jottacloud zal de gebruiker alleen relevante en aangepaste informatie
          sturen over nieuws, producten en diensten van het bedrijf via kanalen
          zoals e-mail en sms-berichten als de gebruiker hiervoor toestemming
          heeft gegeven. De gebruiker kan dergelijke toestemming op elk moment
          intrekken.
        </p>
        <h3>18. Wijzigingen aan de Dienst en de gebruiksvoorwaarden</h3>
        <p>
          Jottacloud behoudt zich het recht voor om de voorwaarden van de
          Overeenkomst met een opzegtermijn van 30 (dertig) dagen te wijzigen.
          Jottacloud behoudt zich eveneens het recht voor om de Dienst geheel of
          gedeeltelijk stop te zetten, te wijzigen of te beëindigen, mits de
          gebruiker ten minste 30 (dertig) dagen voorafgaand aan een dergelijke
          wijziging of beëindiging van de Dienst per e–mail op de hoogte is
          gesteld. Jottacloud behoudt zich het recht voor om de prijzen voor
          lopende abonnementen te wijzigen. Dergelijke wijzigingen worden 30
          (dertig) dagen nadat de kennisgeving is verzonden van kracht. Alle
          kennisgevingen van de bovengenoemde wijzigingen worden per e-mail naar
          de gebruiker verzonden.
        </p>
        <h3>19. Recht op annulering</h3>
        <p>
          De gebruiker heeft een periode van 14 (veertien) dagen na aankoop van
          de Dienst om de Dienst zonder verdere verplichtingen te annuleren. Het
          recht om te annuleren is alleen beschikbaar voor persoonlijke
          accounts.
        </p>
        <h3>20. Overig</h3>
        <p>
          Jottacloud behoudt zich het recht voor om deze Overeenkomst over te
          dragen aan een derde partij. Jottacloud zal gebruikers op de hoogte
          stellen van een dergelijke wijziging. De gebruiker zal 3 (drie) dagen
          van tevoren per e-mail op de hoogte worden gesteld.
        </p>
        <h3>21. Toepasselijk recht en geschillenbeslechting</h3>
        <p>
          Deze Overeenkomst wordt beheerst door en geïnterpreteerd
          overeenkomstig de Noorse wetgeving. De partijen komen overeen dat de
          districtsrechtbank van Oslo de geschikte rechtbank is.
        </p>
        <h3>22. Klantenservice</h3>
        <p>
          Neem bij vragen over de Dienst contact op met de klantenservice via
          e-mail: support@jottacloud.com. Jottacloud zal proberen binnen een
          redelijke termijn te antwoorden op alle vragen.
        </p>
        <h3>23. Contactgegevens en e-mail</h3>
        <p>Jotta AS Øvre Slottsgate 5, support@jottacloud.com.</p>
      </div>
    </article>
  )
}
